import React from 'react'
import DatepickerContainer from '../../../../Components/Forms/FormWidgets/Datepicker'

export default function Datepicker() {
  
  return (
    <div className='page-body'>
        <DatepickerContainer/>
    </div>
  )
}
